<template>
  <el-input-number
    :key="inputKey"
    :value="value"
    :size="size"
    :precision="decimalLength"
    :min="minValue"
    :max="max"
    :step="stepValue"
    @change="changeHanlder"
  ></el-input-number>
</template>

<script>
export default {
  name: "FmNumberDigitBox",
  props: {
    inputKey: {
      type: String,
    },
    value: {
      type: [Number, String],
      default: "0",
    },
    min: {
      type: [String, Number],
      default: 0.0,
    },
    max: {
      type: [String, Number],
      default: 10000000.0,
    },
    size: {
      type: String,
      default: "small",
    },
  },
  watch: {
    value: {
      handler(val) {
        this.getTenantQuantityDigit();
      },
      immediate: true,
    },
    min: {
      handler(newVal, oldVal) {},
      immediate: true,
    },
  },
  data() {
    return {
      decimalLength: 3,
      minValue: 0,
      stepValue: 1,
    };
  },
  updated() {
    this.getTenantQuantityDigit();
  },
  destroyed() {},
  methods: {
    getTenantQuantityDigit() {
      let tenantSimplifiedPojo = this.$storageUtil.getTenantSimplifiedPojo();
      this.decimalLength = Number(
        tenantSimplifiedPojo.commodityQuantityDigit || 0
      );
      if (this.min == 1) {
        this.minValue = this.$jsTool.getTenantDecimalLength();
      } else {
        this.minValue = this.min;
      }
    },
    changeHanlder(val) {
      this.$emit("input", val);
      this.$emit("change", val);
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/fm/FmNumberDigitBox.vue